/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export function classNames( definition: Record<string, boolean> ): string {
	return Object.entries( definition )
		.filter( ( [ , value ] ) => value )
		.map( ( [ key ] ) => key )
		.join( ' ' );
}
